/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {NgModule} from '@angular/core';
import {OverlayModule, PortalModule, MdCommonModule, LIVE_ANNOUNCER_PROVIDER} from '../core';
import {CommonModule} from '@angular/common';
import {MdSnackBar} from './snack-bar';
import {MdSnackBarContainer} from './snack-bar-container';
import {SimpleSnackBar} from './simple-snack-bar';
export class MdSnackBarModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    OverlayModule,
    PortalModule,
    CommonModule,
    MdCommonModule,
  ],
  exports: [MdSnackBarContainer, MdCommonModule],
  declarations: [MdSnackBarContainer, SimpleSnackBar],
  entryComponents: [MdSnackBarContainer, SimpleSnackBar],
  providers: [MdSnackBar, LIVE_ANNOUNCER_PROVIDER]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function MdSnackBarModule_tsickle_Closure_declarations() {
/** @type {?} */
MdSnackBarModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdSnackBarModule.ctorParameters;
}



export {MdSnackBar} from './snack-bar';
export {SnackBarState,SHOW_ANIMATION,HIDE_ANIMATION,MdSnackBarContainer} from './snack-bar-container';
export {MdSnackBarConfig} from './snack-bar-config';
export {MdSnackBarRef} from './snack-bar-ref';
export {SimpleSnackBar} from './simple-snack-bar';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
